<template lang="pug">
v-layout(column)
  v-flex(xs12 text-center).mt-2
    h1.display-3.aiwsibg Termin buchen

  v-flex.mt-6
    v-card.elevation-1(:loading="verified === undefined")
      v-card-title Verifikation
      v-card-text(v-if="verified === true") Verifikation erfolgreich. Wir werden uns zeitnah bei dir mit einem genauen Termin bei dir melden.
      v-card-text(v-if="verified === false") Verifikation fehlgeschlagen
</template>

<script>
export default {
  data: () => ({
    verified: undefined,
  }),
  mounted() {
    window.verd = this
    const self = this
    console.log(self.$route.params)
    const { tel, code } = self.$route.params

    self.socket.emit("verify", { tel, code }, reply => {
      self.verified = reply
    })
  },
}
</script>